import { render } from "./Sliders.vue?vue&type=template&id=c1af66b6&scoped=true"
import script from "../js/sliders.js?vue&type=script&lang=js"
export * from "../js/sliders.js?vue&type=script&lang=js"

import "./Sliders.vue?vue&type=style&index=0&id=c1af66b6&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1af66b6"]])

export default __exports__